import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import AuthLayout from "../layouts/AuthLayout";
import MainLayout from "../layouts/MainLayout";
import LoginPage from "../features/auth/LoginPage";
import DashboardPage from "../pages/DashboardPage";
import SearchPage from "../pages/SearchPage";
import ProfilePage from "../pages/ProfilePage";
import CompaniesPage from "../features/companies/CompaniesPage";
import CompanyDetailPage from "../features/companies/CompanyDetailPage";
import DevicesPage from "../features/devices/DevicesPage";
import LogsPage from "../features/devices/LogsPage";
import CompanyDetailsTab from "../features/companies/tabs/CompanyDetailsTab";
import CompanyUsersTab from "../features/companies/tabs/CompanyUsersTab";
import CompanyDevicesTab from "../features/companies/tabs/CompanyDevicesTab";
import UserDeviceAssignmentsPage from "../features/deviceAssignments/UserDeviceAssignmentsPage";
import TicketsPage from "../features/tickets/TicketsPage";
import AuditLogPage from "../features/auditLog/AuditLogPage";
import OfflineCompaniesPage from "../features/offline/OfflineCompaniesPage";
import NotFoundPage from "../pages/NotFoundPage";
import ProtectedRoute from "./ProtectedRoute";

export default function AppRoutes() {
  const { accessToken } = useSelector((s) => s.auth);

  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route
          path="/login"
          element={accessToken ? <Navigate to="/" replace /> : <LoginPage />}
        />
      </Route>

      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/companies" element={<CompaniesPage />} />
        <Route path="/companies/:id" element={<CompanyDetailPage />}>
          <Route index element={<Navigate to="details" replace />} />
          <Route path="details" element={<CompanyDetailsTab />} />
          <Route path="users" element={<CompanyUsersTab />} />
          <Route path="devices" element={<CompanyDevicesTab />} />
        </Route>
        <Route
          path="/companies/:cid/users/:uid/devices"
          element={<UserDeviceAssignmentsPage />}
        />
        <Route path="/devices" element={<DevicesPage />} />
        <Route path="/devices/:imei/logs" element={<LogsPage />} />
        <Route path="/tickets" element={<TicketsPage />} />
        <Route path="/offline" element={<OfflineCompaniesPage />} />
        <Route path="/audit-log" element={<AuditLogPage />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
